module.exports = __webpack_public_path__ + "static/media/400408_02.a638c4d7.png";